import { typeWriter } from "./typing-effect.js";

document.addEventListener("DOMContentLoaded", () => {
  // --- From Pseudo File: Initialize Animations & Particles ---
  const typingHeading = document.getElementById("typing-heading");
  if (typingHeading) {
    typeWriter(typingHeading, "Get in Touch");
  }

  if (typeof tsParticles !== "undefined") {
    tsParticles.load("tsparticles", {
      fpsLimit: 60,
      interactivity: {
        events: { onHover: { enable: true, mode: "repulse" }, resize: true },
        modes: { repulse: { distance: 100, duration: 0.4 } },
      },
      particles: {
        color: { value: ["#066fff", "#a020f0", "#404040"] },
        links: {
          color: "#404040",
          distance: 160,
          enable: true,
          opacity: 0.65,
          width: 1.2,
        },
        collisions: { enable: true },
        move: {
          direction: "none",
          enable: true,
          outModes: { default: "bounce" },
          random: false,
          speed: 1.2,
          straight: false,
        },
        number: { density: { enable: true, area: 800 }, value: 100 },
        opacity: { value: 0.65 },
        shape: { type: "circle" },
        size: { value: { min: 1, max: 7 } },
      },
      detectRetina: true,
    });
  }

  const observerOptions = { threshold: 0.1, rootMargin: "0px 0px -50px 0px" };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const animation = el.getAttribute("data-animation");
        const delay = parseInt(el.getAttribute("data-delay")) || 0;
        setTimeout(() => {
          el.classList.add(animation, "animated");
        }, delay);
      }
    });
  }, observerOptions);
  document
    .querySelectorAll("[data-animation]")
    .forEach((el) => observer.observe(el));
});
